import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=635ab667"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635ab667')) {
      api.createRecord('635ab667', component.options)
    } else {
      api.reload('635ab667', component.options)
    }
    module.hot.accept("./Tickets.vue?vue&type=template&id=635ab667", function () {
      api.rerender('635ab667', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inbound/Tickets.vue"
export default component.exports